<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'
import Button from '@/common/Button.vue'
import {getTypeOptions} from "@/utils/filter"

const props = defineProps({
    viewId: String,
    filterKey: Number
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed properties
const filter = computed(() => {
    return viewStore.filters?.[props.filterKey] || null
})

const typeOptions = computed(() => {
    if (!filter.value?.type) return []
    return getTypeOptions(filter.value.type) || []
})

const option = computed(() => {
    if (!filter.value || !typeOptions.value.length) return null
    return typeOptions.value.find(o => o.predicate === filter.value.predicate) || null
})

const isSet = computed(() => {
    if (!filter.value) return false
    return filter.value.value !== undefined && filter.value.value !== ''
})

// Methods
const onClick = () => {
    if (!filter.value) return

    viewStore.setFilterProp({
        key: props.filterKey,
        name: 'value',
        value: undefined
    })

    // Safeguard against missing or undefined option object structural checks
    if (option.value && option.value.value !== undefined && typeOptions.value.length > 0) {
        const defaultOption = typeOptions.value[0]

        viewStore.setFilterProp({
            key: props.filterKey,
            name: 'condition',
            value: defaultOption.condition
        })

        viewStore.setFilterProp({
            key: props.filterKey,
            name: 'conditionText',
            value: defaultOption.text
        })
    }
}
</script>

<template>
    <Button v-if="isSet" @click="onClick" class="btn-sm focus-ring"><i class="bi-x-lg"/></Button>
</template>